import(/* webpackMode: "eager" */ "/workspace/pwa/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthSessionGuard"] */ "/workspace/pwa/components/AuthSessionGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BootStatusInit"] */ "/workspace/pwa/components/BootStatusInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CapacitorNativeBoot"] */ "/workspace/pwa/components/CapacitorNativeBoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsentRoot"] */ "/workspace/pwa/components/CookieConsentRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NativeStatusBarSync"] */ "/workspace/pwa/components/NativeStatusBarSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PwaConfirmHost"] */ "/workspace/pwa/components/PwaConfirmHost.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/workspace/pwa/components/QueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SentryBootInit"] */ "/workspace/pwa/components/SentryBootInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/workspace/pwa/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/workspace/pwa/components/ToastProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppRuntimeProvider"] */ "/workspace/pwa/lib/runtime/AppRuntimeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/pwa/node_modules/next/dist/client/script.js");
